module.exports = __webpack_public_path__ + "static/media/Arrangement for Compassionate visit.23081bde.png";